import React, { useState } from "react";
import { format, parse, isValid, addWeeks } from "date-fns";
import axios from "axios";
import { confirmAlert } from "react-confirm-alert";
import {
  Modal,
  Button,
  Col,
  Card,
  Row,
  Form,
  InputGroup,
  Tooltip,
  OverlayTrigger,
  Badge,
} from "react-bootstrap";
import { Formik } from "formik";
import {
  faExclamationCircle,
  faTrash,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DropzoneComponent from "./Dropzone.js";
import { domainConfig } from "../config.js";
import { ShowConfirm } from "../components/Alerts.js";
import { generateSixDigitCode, HelpTooltip } from "../assets/functions.js";
import { schemaAddForm, schemaAddSocialMedia } from "./Json.js";
import NotyfContext from "../contexts/NotyfContext.js";

export const getReactivationDates = (
  currentEventEndDate,
  forceEventEndUpdate = false,
) => {
  const targetDate = addWeeks(new Date(), 1);
  const parsedEventEndDate = currentEventEndDate
    ? parse(currentEventEndDate, "dd/MM/yyyy HH:mm", new Date())
    : null;
  const hasValidFutureEventEndDate =
    isValid(parsedEventEndDate) && parsedEventEndDate > new Date();
  const eventEndDate =
    forceEventEndUpdate || !hasValidFutureEventEndDate
      ? targetDate
      : parsedEventEndDate;
  const registerEndDate =
    targetDate > eventEndDate ? eventEndDate : targetDate;

  return {
    eventEndDate,
    registerEndDate,
    formattedEventEndDate: format(eventEndDate, "dd/MM/yyyy HH:mm"),
    formattedRegisterEndDate: format(registerEndDate, "dd/MM/yyyy HH:mm"),
  };
};

export const renderActiveModules = (jsonData) => {
  const modules = [];

  if (jsonData?.networking?.status) {
    modules.push(
      <Badge key="networking" bg="primary" className="me-1 text-black">
        Networking
      </Badge>,
    );
  }
  if (jsonData?.credentialAccess?.status) {
    modules.push(
      <Badge key="credenciamento" bg="primary" className="me-1 text-black">
        Credenciamento
      </Badge>,
    );
  }
  if (jsonData?.sympla?.status) {
    modules.push(
      <Badge key="sympla" bg="primary" className="me-1 text-black">
        Sympla
      </Badge>,
    );
  }

  if (jsonData?.applications?.status) {
    modules.push(
      <Badge key="aplicativos" bg="primary" className="me-1 text-black">
        Aplicativos
      </Badge>,
    );
  }

  return modules;
};

export const FormCompositionCard = ({
  platform,
  dataAddForm,
  setDataAddForm,
  setModal,
  user,
  values,
  setFieldValue,
}) => {
  const [draggedIndex, setDraggedIndex] = useState(null);

  const activeFields = user
    ? dataAddForm?.fieldsUsers || []
    : dataAddForm?.fields || [];

  const handleDragStart = (index) => {
    setDraggedIndex(index);
  };

  const handleDragOver = (index) => {
    if (draggedIndex === index) return;
    const updatedForm = [...activeFields];
    const [draggedItem] = updatedForm.splice(draggedIndex, 1);
    updatedForm.splice(index, 0, draggedItem);
    setDraggedIndex(index);
    if (user) {
      setDataAddForm((prevDataAddForm) => {
        return {
          ...prevDataAddForm,
          fieldsUsers: updatedForm,
        };
      });
    } else {
      setDataAddForm((prevDataAddForm) => {
        return {
          ...prevDataAddForm,
          fields: updatedForm,
        };
      });
    }
  };

  const handleDragEnd = () => {
    setDraggedIndex(null);
  };

  return (
    <Row className="mx-0">
      <Card className="mb-0 formCard col-md-12 px-0">
        <Card.Body>
          <Col className="text-center mb-2">
            {activeFields.length > 0 && (
              <small className="text-center opacity-75">
                (Clique e arraste para ordenar)
              </small>
            )}
          </Col>
          {activeFields.length > 0 ? (
            <Row>
              {platform === 2 && (
                <Col className="mb-3" md={3} sm={12}>
                  <Button
                    style={{ height: "50px" }}
                    variant="secondary"
                    className={`w-100 b-15`}
                    onClick={() => {
                      setModal((prevState) => ({
                        ...prevState,
                        showModalEmailLabel: true,
                      }));
                    }}
                  >
                    {values?.json?.form?.emailLabel || "E-mail"}
                  </Button>
                </Col>
              )}
              {activeFields.map((valueX, index) => (
                <Col
                  key={"dataAddForm" + index}
                  className="mb-3"
                  md={3}
                  sm={12}
                >
                  <Button
                    style={{ height: "50px" }}
                    key={valueX.inputID}
                    variant="secondary"
                    className={`w-100 b-15`}
                    draggable
                    onDragStart={() => handleDragStart(index)}
                    onDragOver={(e) => {
                      e.preventDefault();
                      handleDragOver(index);
                    }}
                    onClick={() => {
                      setDataAddForm((prevState) => ({
                        ...prevState,
                        addFieldData: valueX,
                      }));
                      if (user) {
                        setModal((prevState) => ({
                          ...prevState,
                          showModalFormUser: true,
                        }));
                      } else {
                        setModal((prevState) => ({
                          ...prevState,
                          showModalForm: true,
                        }));
                      }
                    }}
                    onDragEnd={handleDragEnd}
                  >
                    {valueX.label}
                  </Button>
                </Col>
              ))}
            </Row>
          ) : (
            <>
              {platform === 2 ? (
                <Row>
                  <Col className="mb-3" md={3} sm={12}>
                    <Button
                      style={{ height: "50px" }}
                      variant="secondary"
                      className={`w-100 b-15`}
                      onClick={() => {
                        setModal((prevState) => ({
                          ...prevState,
                          showModalEmailLabel: true,
                        }));
                      }}
                    >
                      {values?.json?.form?.emailLabel || "E-mail"}
                    </Button>
                  </Col>
                </Row>
              ) : (
                <p className="text-center opacity-75">
                  Nenhum campo encontrado
                </p>
              )}
            </>
          )}
        </Card.Body>
        <Col className="mb-3 text-center">
          <Button
            variant="primary"
            className="btn-sm"
            onClick={() => {
              setDataAddForm((prevState) => ({
                ...prevState,
                addFieldData: false,
              }));
              if (user) {
                setModal((prevState) => ({
                  ...prevState,
                  showModalFormUser: true,
                }));
              } else {
                setModal((prevState) => ({
                  ...prevState,
                  showModalForm: true,
                }));
              }
            }}
          >
            Adicionar campo
          </Button>
        </Col>
      </Card>
    </Row>
  );
};

export const hydrateFormFieldVacancies = (fields = [], rawRows = []) => {
  let rows = rawRows;
  if (typeof rows === "string") {
    try {
      rows = JSON.parse(rows);
    } catch (error) {
      rows = [];
    }
  }

  const vacancyRows = Array.isArray(rows) ? rows : [];

  return (Array.isArray(fields) ? fields : []).map((field) => {
    if (field?.type !== "select" || field?.vacancyEnabled !== true) {
      return { ...field, vacancyOptions: [] };
    }

    const rowsByOption = new Map(
      vacancyRows
        .filter((row) => String(row?.field_id ?? row?.fieldId) === String(field.inputID))
        .map((row) => [String(row.option_value ?? row.option ?? ""), row]),
    );
    const existingByOption = new Map(
      (Array.isArray(field.vacancyOptions) ? field.vacancyOptions : []).map((row) => [
        String(row?.option ?? row?.option_value ?? ""),
        row,
      ]),
    );

    const vacancyOptions = (Array.isArray(field.options) ? field.options : [])
      .map((option) => String(option ?? "").trim())
      .filter((option, index, options) => option && options.indexOf(option) === index)
      .map((option) => {
        const row = rowsByOption.get(option) || existingByOption.get(option);
        return {
          option,
          totalAvailable: Number(row?.total_available ?? row?.totalAvailable ?? 0),
          associatedTotal: Number(row?.used ?? row?.associatedTotal ?? 0),
        };
      });

    return { ...field, vacancyOptions };
  });
};

const flattenFormikErrorMessages = (error) => {
  if (typeof error === "string") return [error];
  if (Array.isArray(error)) return error.flatMap(flattenFormikErrorMessages);
  if (error && typeof error === "object") {
    return Object.values(error).flatMap(flattenFormikErrorMessages);
  }
  return [];
};

export const FooterFormComponent = ({
  dataAddForm,
  setDataAddForm,
  setModal,
  touched,
  errors,
  values,
  setFieldValue,
  handlePreviewSuccess,
  handlePreviewError,
  platform,
}) => {
  const [draggedIndex, setDraggedIndex] = useState(null);

  const handleDragStart = (index) => {
    setDraggedIndex(index);
  };

  const handleDragOver = (index) => {
    if (draggedIndex === index) return;

    const updatedForm = [...dataAddForm.socialMedia];
    const [draggedItem] = updatedForm.splice(draggedIndex, 1);
    updatedForm.splice(index, 0, draggedItem);

    setDraggedIndex(index);
    setDataAddForm((prevDataAddForm) => {
      return {
        ...prevDataAddForm,
        socialMedia: updatedForm,
      };
    });
  };

  const handleDragEnd = () => {
    setDraggedIndex(null);
  };

  switch (values.json.layout.footer.type) {
    case "image":
      return (
        <Row className="mb-3 mx-0">
          <Card className="mb-0 col-md-12">
            <Card.Body>
              <Form.Control
                type="hidden"
                name="json.layout.footer.url"
                value={values.json.layout.footer.url}
                onChange={(e) => {
                  setFieldValue("json.layout.footer.url", e.target.value);
                }}
                isInvalid={!!errors.json?.layout?.footer?.url}
                isValid={
                  touched.json?.layout?.footer?.width &&
                  !errors.json?.layout?.footer?.url
                }
              />
              <div className="imagesUpload">
                <img
                  className={`h-100 img-thumbnail ${!!errors.json?.layout?.footer?.url ? "is-invalid" : ""}`}
                  src={
                    values.json.layout.footer.url !== "" &&
                      values.json.layout.footer.url !== null
                      ? domainConfig.imageServer +
                      (platform === 1 ? "/evento/" : "/plataforma-eventos/") +
                      (platform === 1 ? values.evento_id : values.event_id) +
                      "/" +
                      values.json.layout.footer.url
                      : domainConfig.imageServer + "/empty-background.png"
                  }
                  alt="Imagem preview"
                />
                <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  {errors.json?.layout?.footer?.url}
                </Form.Control.Feedback>
              </div>
              <DropzoneComponent
                className="mt-3 dropzoneComp"
                type="image"
                handlePreviewSuccess={handlePreviewSuccess}
                handlePreviewError={handlePreviewError}
                setFieldValue={setFieldValue}
                folder={platform === 1 ? "evento" : "plataforma-eventos"}
                id={platform === 1 ? values.evento_id : values.event_id}
                field="json.layout.footer.url"
              />
              <Form.Group as={Col} className="mt-3">
                <Form.Label>Largura (px)</Form.Label>
                <Form.Control
                  type="number"
                  name="json.layout.footer.width"
                  value={values.json.layout.footer.width}
                  onChange={(e) => {
                    setFieldValue("json.layout.footer.width", e.target.value);
                  }}
                  isInvalid={!!errors.json?.layout?.footer?.width}
                  isValid={
                    touched.json?.layout?.footer?.width &&
                    !errors.json?.layout?.footer?.width
                  }
                />
                <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  {errors.json?.layout?.footer?.width}
                </Form.Control.Feedback>
              </Form.Group>
            </Card.Body>
          </Card>
        </Row>
      );
    case "icons":
      return (
        <Row className="mb-3 mx-0">
          <Card className="mb-0 formCard col-md-12 px-0">
            <Card.Body>
              <Col className="text-center mb-2">
                {dataAddForm.socialMedia.length > 0 && (
                  <small className="text-center opacity-75">
                    (Clique e arraste para ordenar)
                  </small>
                )}
              </Col>
              {dataAddForm.socialMedia.length > 0 ? (
                <Row>
                  {dataAddForm.socialMedia.map((valueX, index) => (
                    <Col
                      key={"dataAddForm" + index}
                      className="mb-3"
                      md={3}
                      sm={12}
                    >
                      <Button
                        style={{ height: "50px" }}
                        variant="secondary"
                        className={`w-100 b-15`}
                        draggable
                        onDragStart={() => handleDragStart(index)}
                        onDragOver={(e) => {
                          e.preventDefault();
                          handleDragOver(index);
                        }}
                        onClick={() => {
                          setDataAddForm((prevState) => ({
                            ...prevState,
                            addFieldData: valueX,
                          }));
                          setModal((prevState) => ({
                            ...prevState,
                            showSocialMediaForm: true,
                          }));
                        }}
                        onDragEnd={handleDragEnd}
                      >
                        {valueX.name}
                      </Button>
                    </Col>
                  ))}
                </Row>
              ) : (
                <>
                  <p className="text-center opacity-75">
                    Nenhum ícone encontrado
                  </p>
                </>
              )}
            </Card.Body>
            <Col className="mb-3 text-center">
              <Button
                variant="primary"
                className="btn-sm"
                onClick={() => {
                  setDataAddForm((prevState) => ({
                    ...prevState,
                    addFieldData: false,
                  }));
                  setModal((prevState) => ({
                    ...prevState,
                    showSocialMediaForm: true,
                  }));
                }}
              >
                Adicionar ícone
              </Button>
            </Col>
          </Card>
        </Row>
      );
    default:
      return "";
  }
};

export const FormType = ({
  platform,
  dataAddForm,
  setDataAddForm,
  modal,
  setModal,
  user,
  formData,
  setEventFieldValue,
}) => {
  const buildVacancyOptions = (options, currentVacancyOptions = []) => {
    const currentByOption = new Map(
      (Array.isArray(currentVacancyOptions) ? currentVacancyOptions : []).map((row) => [
        String(row?.option ?? row?.option_value ?? ""),
        row,
      ]),
    );

    return (Array.isArray(options) ? options : [])
      .map((option) => String(option ?? "").trim())
      .filter((option, index, normalizedOptions) => option && normalizedOptions.indexOf(option) === index)
      .map((option) => {
        const current = currentByOption.get(option);
        return {
          option,
          totalAvailable: Number(current?.totalAvailable ?? current?.total_available ?? 0),
          associatedTotal: Number(current?.associatedTotal ?? current?.used ?? 0),
        };
      });
  };

  const normalizeFieldValidation = (type, validation) => {
    if (type === "textarea") {
      return validation === "textBig" ? "textBig" : "text";
    }

    return validation;
  };

  const [showAdditionalData, setShowAdditionalData] = useState(false);
  const [pendingVacancyCleanupFieldId, setPendingVacancyCleanupFieldId] = useState(null);
  const activeFields = user
    ? dataAddForm?.fieldsUsers || []
    : dataAddForm?.fields || [];
  const notyf = React.useContext(NotyfContext);
  function handleRfidTagChange(setFieldValue, currentValue) {
    const nextValue = !currentValue;

    setFieldValue("rfigtag", nextValue);

    if (nextValue) {
      setFieldValue("type", "input");
      setFieldValue("validation", "text");
    }
  }

  const whatsappControl = (values, setFieldValue) => platform === 2 && (values.whatsapp
    || (values.type === "input" && values.validation === "telefone")) ? <><Form.Check
      checked={values.whatsapp === true} type="checkbox" name="whatsapp"
      label="Utilizar este campo para envio de mensagens de WhatsApp"
      onChange={() => {
        if (!values.whatsapp && [...(dataAddForm.fields || []), ...(dataAddForm.fieldsUsers || [])]
          .some((field) => field.whatsapp === true && String(field.inputID) !== String(values.inputID))) {
          notyf.open({ type: "danger", message: "Já existe um campo definido para envio de mensagens de WhatsApp." });
          return;
        }
        setFieldValue("whatsapp", !values.whatsapp);
        if (!values.whatsapp) {
          setFieldValue("rfigtag", false);
          setFieldValue("required", true);
          setFieldValue("hideFieldOnRegister", false);
          setFieldValue("dependencies", []);
        }
      }} /></> : null;

  function syncEventRfidStatus(fields) {
    if (platform !== 2 || user || typeof setEventFieldValue !== "function") {
      return;
    }

    setEventFieldValue(
      "json.credentialAccess.apresentation.afterCheckin.rfid.status",
      Array.isArray(fields) && fields.some((field) => field?.rfigtag === true),
    );
  }

  const getEventId = () => formData?.evento_id ?? formData?.event_id;

  async function clearVacancyAssociations(fieldId, optionValue = null) {
    const eventId = getEventId();
    if (!eventId) {
      throw new Error("Não foi possível identificar o evento.");
    }

    const params = {
      evento_id: eventId,
      platform,
      field_id: fieldId,
    };
    if (optionValue !== null) {
      params.option_value = optionValue;
    }

    const response = await axios.delete(
      "/api/event/form-field-vacancy-associations",
      { params },
    );
    return response.data;
  }

  const updateVacancyAssociationCount = (fieldId, optionValue, count) => {
    setDataAddForm((prevDataAddForm) => {
      const updateField = (field) => {
        if (field.inputID !== fieldId) return field;
        const vacancyOptions = (Array.isArray(field.vacancyOptions)
          ? field.vacancyOptions
          : []
        ).map((row) => (
          String(row?.option ?? row?.option_value ?? "") === String(optionValue)
            ? { ...row, associatedTotal: count }
            : row
        ));
        return { ...field, vacancyOptions };
      };

      return {
        ...prevDataAddForm,
        fields: (prevDataAddForm.fields || []).map(updateField),
        addFieldData:
          prevDataAddForm.addFieldData?.inputID === fieldId
            ? updateField(prevDataAddForm.addFieldData)
            : prevDataAddForm.addFieldData,
      };
    });
  };

  const confirmClearVacancyOption = (
    fieldId,
    optionValue,
    associatedTotal,
    currentOptions,
    currentFieldOptions,
    setFieldValue,
  ) => {
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => (
        <ShowConfirm
          title="Limpar associações?"
          description={`Isso removerá ${associatedTotal} associação(ões) de participantes da opção "${optionValue}".`}
          action={async () => {
            try {
              await clearVacancyAssociations(fieldId, optionValue);
              const nextOptions = buildVacancyOptions(
                currentFieldOptions,
                currentOptions,
              ).map((row) => (
                row.option === optionValue
                  ? { ...row, associatedTotal: 0 }
                  : row
              ));
              setFieldValue("vacancyOptions", nextOptions);
              updateVacancyAssociationCount(fieldId, optionValue, 0);
              notyf.open({
                type: "success",
                message: `As associações da opção "${optionValue}" foram limpas.`,
                ripple: true,
                dismissible: true,
              });
            } catch (error) {
              notyf.open({
                type: "danger",
                message:
                  error?.response?.data?.message ||
                  error?.message ||
                  "Não foi possível limpar as associações da opção.",
                ripple: true,
                dismissible: true,
              });
            }
          }}
          onClose={onClose}
          textConfirm="Limpar associações"
        />
      ),
    });
  };

  function addForm(values, actions) {
    const shouldConfirmSelectionFieldSave =
      !user &&
      values.type === "select" &&
      values.vacancyEnabled === true &&
      values.required === true;

    if (shouldConfirmSelectionFieldSave) {
      confirmAlert({
        closeOnEscape: false,
        closeOnClickOutside: false,
        customUI: ({ onClose }) => (
          <ShowConfirm
            title="Atenção"
            description="Se manter o campo como obrigatório, o usuário não conseguirá se registrar caso não tenha mais vagas disponíveis. Deseja continuar?"
            action={() => saveForm(values, actions)}
            onClose={() => {
              if (actions && typeof actions.setSubmitting === "function") {
                actions.setSubmitting(false);
              }
              onClose();
            }}
            textConfirm="Continuar"
          />
        ),
      });
      return;
    }

    return saveForm(values, actions);
  }

  async function saveForm(values, actions) {
    const currentField = activeFields.find(
      (field) => field.inputID === values.inputID,
    );
    if (platform === 2 && values.whatsapp && (values.type !== "input" || values.validation !== "telefone")) {
      notyf.open({ type: "danger", message: "O campo de WhatsApp deve ter validação telefone." });
      actions?.setSubmitting(false);
      return;
    }
    if (platform === 1 && values.primary) {
      const existingPrimary = activeFields.find(
        (field) => field.primary === true && field.inputID !== values.inputID
      );
      if (existingPrimary) {
        notyf.open({
          type: "danger",
          message: 'Já existe um campo definido como "Campo primário"',
          ripple: true,
          dismissible: true,
        });
        if (actions && typeof actions.setSubmitting === "function") {
          actions.setSubmitting(false);
        }
        return;
      }
    }

    if (!user && platform === 2 && values.rfigtag) {
      const existingRfid = activeFields.find(
        (field) => field.rfigtag === true && field.inputID !== values.inputID
      );
      if (existingRfid) {
        notyf.open({
          type: "danger",
          message: 'Já existe um campo definido como "RFID tag"',
          ripple: true,
          dismissible: true,
        });
        if (actions && typeof actions.setSubmitting === "function") {
          actions.setSubmitting(false);
        }
        return;
      }
    }

    const isParticipantRfidField =
      !user && platform === 2 && values.rfigtag === true;
    const newObject = {
      ...values,
      whatsapp: platform === 2 && values.whatsapp === true,
      required: values.whatsapp === true ? true : values.required,
      hideFieldOnRegister: values.whatsapp === true ? false : values.hideFieldOnRegister,
      dependencies: values.whatsapp === true ? [] : values.dependencies,
      rfigtag: platform === 2 ? isParticipantRfidField : values.rfigtag,
      type: isParticipantRfidField ? "input" : values.type,
      validation:
        isParticipantRfidField
          ? "text"
          : normalizeFieldValidation(values.type, values.validation),
    };
    const shouldClearVacancyAssociations =
      !user &&
      currentField?.vacancyEnabled === true &&
      values.vacancyEnabled !== true &&
      pendingVacancyCleanupFieldId === values.inputID;

    newObject.options = newObject.options !== "" ? newObject.options : [];
    let vacancyOptions = newObject.vacancyEnabled
      ? buildVacancyOptions(newObject.options, values.vacancyOptions)
      : [];

    if (shouldClearVacancyAssociations) {
      try {
        await clearVacancyAssociations(values.inputID);
      } catch (error) {
        notyf.open({
          type: "danger",
          message:
            error?.response?.data?.message ||
            error?.message ||
            "Não foi possível limpar as associações dos participantes.",
          ripple: true,
          dismissible: true,
        });
        if (actions && typeof actions.setSubmitting === "function") {
          actions.setSubmitting(false);
        }
        return;
      }

      vacancyOptions = vacancyOptions.map((row) => ({
        ...row,
        associatedTotal: 0,
      }));
      setPendingVacancyCleanupFieldId(null);
      notyf.open({
        type: "success",
        message: "As associações dos participantes foram limpas.",
        ripple: true,
        dismissible: true,
      });
    }

    // eslint-disable-next-line eqeqeq
    if (!user) {
      if (values.fieldToShow) {
        addFieldToShow(values.inputID);
      } else {
        removeFieldToShow(values.inputID);
      }
    }
    newObject.vacancyEnabled =
      !user && newObject.type === "select" && values.vacancyEnabled === true;
    newObject.vacancyOptions = vacancyOptions;

    if (!user && platform === 2) {
      const nextParticipantFields = [...activeFields];
      const fieldIndex = nextParticipantFields.findIndex(
        (field) => field.inputID === values.inputID,
      );
      if (fieldIndex === -1) {
        nextParticipantFields.push(newObject);
      } else {
        nextParticipantFields[fieldIndex] = newObject;
      }
      syncEventRfidStatus(nextParticipantFields);
    }

    // The WhatsApp phone field is saved only in the composition being edited.
    // Automatic WhatsApp asks for it in the other composition only when that
    // composition's user types are enabled (WhatsAppRegistrationFields adds it).
    setDataAddForm((prevDataAddForm) => {
      if (user) {
        const indexToUpdate = prevDataAddForm.fieldsUsers.findIndex(
          (field) => field.inputID === values.inputID,
        );
        let props = [...prevDataAddForm.fieldsUsers];

        if (indexToUpdate !== -1) {
          props[indexToUpdate] = newObject;
        } else {
          props = [...props, newObject];
        }
        return {
          ...prevDataAddForm,
          fieldsUsers: props,
        };
      } else {
        const indexToUpdate = prevDataAddForm.fields.findIndex(
          (field) => field.inputID === values.inputID,
        );
        let props = [...prevDataAddForm.fields];

        if (indexToUpdate !== -1) {
          props[indexToUpdate] = newObject;
        } else {
          props = [...props, newObject];
        }
        return {
          ...prevDataAddForm,
          fields: props,
        };
      }
    });
    setPendingVacancyCleanupFieldId(null);
    if (user) {
      setModal((prevState) => ({
        ...prevState,
        showModalFormUser: false,
      }));
    } else {
      setModal((prevState) => ({
        ...prevState,
        showModalForm: false,
      }));
    }
  }

  function removeFieldForm(inputID) {
    const fieldToRemove = activeFields.find((field) => field.inputID === inputID);

    if (!user && platform === 2 && fieldToRemove?.rfigtag === true) {
      syncEventRfidStatus(
        activeFields.filter((field) => field.inputID !== inputID),
      );
    }

    // Removing the WhatsApp phone field affects only the composition being edited.
    setDataAddForm((prevDataAddForm) => {
      if (user) {
        const indexToRemove = prevDataAddForm.fieldsUsers.findIndex(
          (field) => field.inputID === inputID,
        );
        const props = [...prevDataAddForm.fieldsUsers];
        props.splice(indexToRemove, 1);
        return {
          ...prevDataAddForm,
          fieldsUsers: props,
        };
      } else {
        const indexToRemove = prevDataAddForm.fields.findIndex(
          (field) => field.inputID === inputID,
        );
        const props = [...prevDataAddForm.fields];
        props.splice(indexToRemove, 1);
        return {
          ...prevDataAddForm,
          fields: props,
        };
      }
    });

    return true;
  }

  const renderValidations = (type) => {
    const index = fieldsTypeX.findIndex((field) => field.type === type);
    return fieldsTypeX[index].validations.map((element, index) => (
      <option key={"validationfieldType" + index} value={element.value}>
        {element.label}
      </option>
    ));
  };

  const addFieldToShow = (inputID) => {
    setDataAddForm((prevDataAddForm) => {
      const indexToUpdate = prevDataAddForm.fieldsToShow.findIndex(
        (field) => field === inputID,
      );
      let props = [...prevDataAddForm.fieldsToShow];
      if (indexToUpdate === -1) {
        props = [...props, inputID];
      }
      return {
        ...prevDataAddForm,
        fieldsToShow: props,
      };
    });
  };

  const removeFieldToShow = (inputID) => {
    setDataAddForm((prevDataAddForm) => {
      const indexToRemove = prevDataAddForm.fieldsToShow.findIndex(
        (field) => field === inputID,
      );
      if (indexToRemove === -1) {
        return prevDataAddForm;
      }
      const newFieldsToShow = [...prevDataAddForm.fieldsToShow];
      newFieldsToShow.splice(indexToRemove, 1);
      return {
        ...prevDataAddForm,
        fieldsToShow: newFieldsToShow,
      };
    });
  };

  return (
    <>
      <Modal
        show={modal.showModalForm || modal.showModalFormUser}
        size={"sm"}
        onHide={(e) => {
          if (user) {
            setModal((prevState) => ({
              ...prevState,
              showModalFormUser: false,
            }));
          } else {
            setModal((prevState) => ({
              ...prevState,
              showModalForm: false,
            }));
          }
          setDataAddForm((prevState) => ({
            ...prevState,
            addFieldData: false,
          }));
          setPendingVacancyCleanupFieldId(null);
        }}
        fullscreen={"sm-down"}
        centered
        backdrop
      >
        <Formik
          key={"FormikSchemaAddForm"}
          validationSchema={() => schemaAddForm()}
          onSubmit={addForm}
          initialValues={{
            inputID:
              dataAddForm.addFieldData.inputID !== undefined
                ? dataAddForm.addFieldData.inputID
                : generateSixDigitCode(),
            label:
              dataAddForm.addFieldData.label !== undefined
                ? dataAddForm.addFieldData.label
                : "",
            subLabel:
              dataAddForm.addFieldData.subLabel !== undefined
                ? dataAddForm.addFieldData.subLabel
                : "",
            type:
              dataAddForm.addFieldData.type !== undefined
                ? dataAddForm.addFieldData.type
                : fieldsTypeX[0].type,
            validation:
              normalizeFieldValidation(
                dataAddForm.addFieldData.type !== undefined
                  ? dataAddForm.addFieldData.type
                  : fieldsTypeX[0].type,
                dataAddForm.addFieldData.validation !== undefined
                  ? dataAddForm.addFieldData.validation
                  : fieldsTypeX[0].validations[0].value,
              ),
            defaultValue:
              dataAddForm.addFieldData.defaultValue !== undefined
                ? dataAddForm.addFieldData.defaultValue
                : "",
            placeholder:
              dataAddForm.addFieldData.placeholder !== undefined
                ? dataAddForm.addFieldData.placeholder
                : "",
            col:
              dataAddForm.addFieldData.col !== undefined
                ? dataAddForm.addFieldData.col
                : 12,
            primary:
              dataAddForm.addFieldData.primary !== undefined
                ? dataAddForm.addFieldData.primary
                : false,
            options:
              dataAddForm.addFieldData.options !== undefined
                ? dataAddForm.addFieldData.options
                : [],
            required:
              dataAddForm.addFieldData.required !== undefined
                ? dataAddForm.addFieldData.required
                : true,
            allowMultipleChoice:
              dataAddForm.addFieldData.allowMultipleChoice !== undefined
                ? dataAddForm.addFieldData.allowMultipleChoice
                : false,
            allowMultipleChoiceMax:
              dataAddForm.addFieldData.allowMultipleChoiceMax !== undefined
                ? dataAddForm.addFieldData.allowMultipleChoiceMax
                : 1,
            allowMultipleChoiceMin:
              dataAddForm.addFieldData.allowMultipleChoiceMin !== undefined
                ? dataAddForm.addFieldData.allowMultipleChoiceMin
                : 1,
            vacancyEnabled:
              dataAddForm.addFieldData.vacancyEnabled !== undefined
                ? dataAddForm.addFieldData.vacancyEnabled
                : false,
            vacancyOptions:
              dataAddForm.addFieldData.vacancyOptions !== undefined
                ? dataAddForm.addFieldData.vacancyOptions
                : [],
            dependencies:
              dataAddForm.addFieldData.dependencies !== undefined &&
                Array.isArray(dataAddForm.addFieldData.dependencies)
                ? dataAddForm.addFieldData.dependencies
                : [],
            displayField:
              dataAddForm.addFieldData.displayField !== undefined
                ? dataAddForm.addFieldData.displayField
                : true,
            blockEdit:
              dataAddForm.addFieldData.blockEdit !== undefined
                ? dataAddForm.addFieldData.blockEdit
                : false,
            blockEditMessage:
              dataAddForm.addFieldData.blockEditMessage !== undefined
                ? dataAddForm.addFieldData.blockEditMessage
                : "",
            fieldToShow:
              dataAddForm.addFieldData.fieldToShow !== undefined
                ? dataAddForm.addFieldData.fieldToShow
                : activeFields.length === 0
                  ? true
                  : false,
            _id:
              dataAddForm.addFieldData._id !== undefined
                ? dataAddForm.addFieldData._id
                : "",
            hideFieldOnRegister:
              dataAddForm.addFieldData.hideFieldOnRegister !== undefined
                ? dataAddForm.addFieldData.hideFieldOnRegister
                : false,
            fieldWithUppercase:
              dataAddForm.addFieldData.fieldWithUppercase !== undefined
                ? dataAddForm.addFieldData.fieldWithUppercase
                : false,
            showInUserReport:
              dataAddForm.addFieldData.showInUserReport !== undefined
                ? dataAddForm.addFieldData.showInUserReport
                : true,
            rfigtag:
              dataAddForm.addFieldData.rfigtag !== undefined
                ? dataAddForm.addFieldData.rfigtag
                : false,
            whatsapp: dataAddForm.addFieldData.whatsapp === true,
          }}
        >
          {({
            handleSubmit,
            handleChange,
            values,
            touched,
            isValid,
            errors,
            dirty,
            isSubmitting,
            setFieldValue,
          }) => (
            <Form noValidate onSubmit={handleSubmit}>
              <Modal.Header closeButton>
                <Modal.Title>
                  {dataAddForm.addFieldData
                    ? "Editar Campo"
                    : "Adicionar campo"}
                  <br></br>
                  <small>
                    ID: <span className="opacity-75">{values.inputID}</span>
                  </small>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Form.Group className="mb-3" as={Col} sm={"12"}>
                    <Form.Label>Título</Form.Label>
                    <Form.Control
                      type="text"
                      name="label"
                      value={values.label}
                      onChange={handleChange}
                      isInvalid={!!errors.label}
                      isValid={touched.label && !errors.label}
                    />
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                      {errors.label}
                    </Form.Control.Feedback>
                  </Form.Group>

                  {!values.rfigtag && (
                    <Form.Group as={Col} className={"mb-3"} sm={"6"}>
                      <Form.Label>Tipo</Form.Label>
                      <Form.Select
                        name="type"
                        value={values.type}
                        onChange={(e) => {
                          const selectedElement = fieldsTypeX.find(
                            (field) => field.type === e.target.value,
                          );
                          const applyTypeChange = () => {
                            setPendingVacancyCleanupFieldId(null);
                            if (selectedElement.type === "select") {
                              setFieldValue("validation", "text");
                              setFieldValue("fieldToShow", false);
                            } else if (selectedElement.type === "input") {
                              setFieldValue("validation", "text");
                            } else if (selectedElement.type === "checkbox") {
                              setFieldValue("validation", "checkbox");
                              setFieldValue("fieldToShow", false);
                            } else if (selectedElement.type === "textarea") {
                              setFieldValue("validation", "text");
                              setFieldValue("fieldToShow", false);
                            }
                            setFieldValue("primary", selectedElement.type === "input" ? values.primary : false);
                            setFieldValue("type", selectedElement.type);
                            if (selectedElement.type !== "select") {
                              setFieldValue("vacancyEnabled", false);
                              setFieldValue("vacancyOptions", []);
                            } else if (values.vacancyEnabled) {
                              setFieldValue(
                                "vacancyOptions",
                                buildVacancyOptions(values.options, values.vacancyOptions),
                              );
                            }
                          };

                          applyTypeChange();
                        }}
                        isInvalid={!!errors.type}
                        isValid={touched.type && !errors.type}
                      >
                        {fieldsTypeX.map((element, index) => {
                          const capitalizeFirstLetter = ([
                            firstLetter,
                            ...rest
                          ]) => firstLetter.toUpperCase() + rest.join("");
                          const capitalizedString = capitalizeFirstLetter(
                            element.name,
                          );

                          return (
                            <option
                              key={"fieldType" + index}
                              value={element.type}
                            >
                              {capitalizedString}
                            </option>
                          );
                        })}
                      </Form.Select>
                      <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                      <Form.Control.Feedback type="invalid">
                        {errors.type}
                      </Form.Control.Feedback>
                    </Form.Group>
                  )}

                  {values.type === "input" && !values.rfigtag && (
                    <Form.Group as={Col} className={"mb-3"} sm={"6"}>
                      <Form.Label>Validação</Form.Label>
                      <Form.Select
                        name="validation"
                        value={values.validation}
                        onChange={handleChange}
                        isInvalid={!!errors.validation}
                        isValid={touched.validation && !errors.validation}
                      >
                        {renderValidations(values.type)}
                      </Form.Select>
                      <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                      <Form.Control.Feedback type="invalid">
                        {errors.validation}
                      </Form.Control.Feedback>
                    </Form.Group>
                  )}

                  {(values.type === "select" || values.type === "checkbox") && (
                    <Form.Group className="mb-3" as={Col} sm={"12"}>
                      <Form.Label>
                        Opções
                        <OverlayTrigger
                          overlay={
                            <Tooltip>
                              Separe as opções por linha.
                              {values.type === "checkbox"
                                ? " Se não houver opções o checkbox será único"
                                : ""}
                            </Tooltip>
                          }
                        >
                          <HelpTooltip icon={faExclamationCircle} />
                        </OverlayTrigger>
                      </Form.Label>
                      <Form.Control
                        style={{ height: "75px" }}
                        as={"textarea"}
                        name="options"
                        value={values.options.join("\n")}
                        onChange={(e) => {
                          const updatedOptions = e.target.value.split("\n");
                          setFieldValue("options", updatedOptions);
                        }}
                        isInvalid={!!errors.options}
                        isValid={touched.options && !errors.options}
                      />
                      <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                      <Form.Control.Feedback type="invalid">
                        {errors.options}
                      </Form.Control.Feedback>
                    </Form.Group>
                  )}

                  {values.type === "select" && !user && (
                    <Form.Group className="mb-3" as={Col} sm={"12"}>
                      <Form.Check
                        checked={values.vacancyEnabled === true}
                        type="checkbox"
                        name="vacancyEnabled"
                        label="Controlar vagas por opção"
                        onChange={() => {
                          const isExistingVacancyField = activeFields.some(
                            (field) =>
                              field.inputID === values.inputID &&
                              field.vacancyEnabled === true,
                          );
                          if (values.vacancyEnabled && isExistingVacancyField) {
                            confirmAlert({
                              closeOnEscape: false,
                              closeOnClickOutside: false,
                              customUI: ({ onClose }) => (
                                <ShowConfirm
                                  title="Desativar sistema de vagas?"
                                  description="As associações dos participantes para todas as opções deste campo serão excluídas ao salvar o campo."
                                  action={() => {
                                    setPendingVacancyCleanupFieldId(values.inputID);
                                    setFieldValue("vacancyEnabled", false);
                                  }}
                                  onClose={onClose}
                                  textConfirm="Desativar"
                                />
                              ),
                            });
                            return;
                          }

                          setPendingVacancyCleanupFieldId(null);
                          if (values.vacancyEnabled) {
                            setFieldValue("vacancyEnabled", false);
                            return;
                          }
                          setFieldValue("vacancyEnabled", true);
                          setFieldValue(
                            "vacancyOptions",
                            buildVacancyOptions(values.options, values.vacancyOptions),
                          );
                        }}
                      />
                      {values.vacancyEnabled && (
                        <>
                          {(values.options || [])
                            .map((option) => String(option ?? "").trim())
                            .filter((option, index, options) => option && options.indexOf(option) === index)
                            .map((option) => {
                              const optionIndex = values.vacancyOptions.findIndex(
                                (row) => String(row.option) === option,
                              );
                              const vacancyOption = values.vacancyOptions[optionIndex] || {
                                option,
                                totalAvailable: 0,
                                associatedTotal: 0,
                              };

                              return (
                                <Row className="align-items-end mb-2" key={`vacancy-${option}`}>
                                  <Col sm="7">
                                    <Form.Label className="small mb-1">{`Opção: ${option}`}</Form.Label>
                                    <Form.Control
                                      type="number"
                                      min={Number(vacancyOption.associatedTotal ?? vacancyOption.used ?? 0)}
                                      step="1"
                                      value={vacancyOption.totalAvailable}
                                      aria-label={`Total disponível para ${option}`}
                                      onChange={(event) => {
                                        const associatedTotal = Number(
                                          vacancyOption.associatedTotal ?? vacancyOption.used ?? 0,
                                        );
                                        const enteredValue = Number(event.target.value);
                                        const totalAvailable = Number.isFinite(enteredValue)
                                          ? Math.max(Math.trunc(enteredValue), associatedTotal)
                                          : associatedTotal;
                                        const nextOptions = buildVacancyOptions(
                                          values.options,
                                          values.vacancyOptions,
                                        );
                                        const nextIndex = nextOptions.findIndex(
                                          (row) => row.option === option,
                                        );
                                        nextOptions[nextIndex] = {
                                          ...nextOptions[nextIndex],
                                          totalAvailable,
                                        };
                                        setFieldValue("vacancyOptions", nextOptions);
                                      }}
                                      isInvalid={Boolean(errors.vacancyOptions)}
                                    />
                                  </Col>
                                  <Col sm="5">
                                    <Form.Label className="small mb-1">Vagas ocupadas</Form.Label>
                                    <InputGroup>
                                      <Form.Control
                                        type="number"
                                        value={Number(vacancyOption.associatedTotal ?? vacancyOption.used ?? 0)}
                                        disabled
                                        aria-label={`Vagas ocupadas para ${option}`}
                                      />
                                      <Button
                                        type="button"
                                        variant="outline-danger"
                                        title={`Limpar associações de ${option}`}
                                        aria-label={`Limpar associações de ${option}`}
                                        disabled={Number(vacancyOption.associatedTotal ?? vacancyOption.used ?? 0) <= 0}
                                        onClick={() =>
                                          confirmClearVacancyOption(
                                            values.inputID,
                                            option,
                                            Number(vacancyOption.associatedTotal ?? vacancyOption.used ?? 0),
                                            values.vacancyOptions,
                                            values.options,
                                            setFieldValue,
                                          )
                                        }
                                      >
                                        <FontAwesomeIcon icon={faTrash} />
                                      </Button>
                                    </InputGroup>
                                  </Col>
                                </Row>
                              );
                            })}
                          <Form.Control.Feedback type="invalid" className="d-block">
                            {flattenFormikErrorMessages(errors.vacancyOptions).join(" ")}
                          </Form.Control.Feedback>
                        </>
                      )}
                    </Form.Group>
                  )}

                  {values.type === "checkbox" && values.options.length >= 2 && (
                    <Form.Group
                      className={values.allowMultipleChoice ? "" : "mb-3"}
                      as={Col}
                      sm={"12"}
                    >
                      <Form.Check
                        checked={values.allowMultipleChoice ? true : false}
                        type="checkbox"
                        name="allowMultipleChoice"
                        label="Múltipla escolha"
                        value={values.allowMultipleChoice}
                        onChange={(e) => {
                          setFieldValue(
                            "allowMultipleChoice",
                            values.allowMultipleChoice ? false : true,
                          );
                        }}
                      />
                    </Form.Group>
                  )}

                  {values.allowMultipleChoice === true && (
                    <>
                      <Form.Group className="mb-3" as={Col} sm={"6"}>
                        <Form.Label>Mínimo</Form.Label>
                        <Form.Control
                          type="number"
                          name="allowMultipleChoiceMin"
                          value={values.allowMultipleChoiceMin}
                          onChange={handleChange}
                          isInvalid={!!errors.allowMultipleChoiceMin}
                          isValid={
                            touched.allowMultipleChoiceMin &&
                            !errors.allowMultipleChoiceMin
                          }
                        />
                        <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                        <Form.Control.Feedback type="invalid">
                          {errors.allowMultipleChoiceMin}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group className="mb-3" as={Col} sm={"6"}>
                        <Form.Label>Máximo</Form.Label>
                        <Form.Control
                          type="number"
                          name="allowMultipleChoiceMax"
                          value={values.allowMultipleChoiceMax}
                          onChange={handleChange}
                          isInvalid={!!errors.allowMultipleChoiceMax}
                          isValid={
                            touched.allowMultipleChoiceMax &&
                            !errors.allowMultipleChoiceMax
                          }
                        />
                        <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                        <Form.Control.Feedback type="invalid">
                          {errors.allowMultipleChoiceMax}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </>
                  )}

                  {showAdditionalData ? (
                    <>
                      <Form.Group className="mb-3" as={Col} sm={"12"}>
                        <Form.Label>Subtítulo</Form.Label>
                        <Form.Control
                          type="text"
                          name="subLabel"
                          value={values.subLabel}
                          onChange={handleChange}
                          isInvalid={!!errors.subLabel}
                          isValid={touched.subLabel && !errors.subLabel}
                        />
                        <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                        <Form.Control.Feedback type="invalid">
                          {errors.subLabel}
                        </Form.Control.Feedback>
                      </Form.Group>

                      {(values.type === "input" ||
                        values.type === "select" ||
                        values.type === "textarea") && (
                          <Form.Group className="mb-3" as={Col} sm={"12"}>
                            <Form.Label>Valor padrão</Form.Label>
                            {values.type === "select" ? (
                              <Form.Select
                                name="defaultValue"
                                value={values.defaultValue}
                                onChange={handleChange}
                                isInvalid={!!errors.defaultValue}
                                isValid={
                                  touched.defaultValue && !errors.defaultValue
                                }
                              >
                                <option value="">Nenhum valor padrão</option>
                                {values.options
                                  .map((option) => String(option ?? "").trim())
                                  .filter(
                                    (option, index, options) =>
                                      option && options.indexOf(option) === index,
                                  )
                                  .map((option) => (
                                    <option key={`default-value-${option}`} value={option}>
                                      {option}
                                    </option>
                                  ))}
                              </Form.Select>
                            ) : (
                              <Form.Control
                                type="text"
                                name="defaultValue"
                                value={values.defaultValue}
                                onChange={handleChange}
                                isInvalid={!!errors.defaultValue}
                                isValid={
                                  touched.defaultValue && !errors.defaultValue
                                }
                              />
                            )}
                            <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                            <Form.Control.Feedback type="invalid">
                              {errors.defaultValue}
                            </Form.Control.Feedback>
                          </Form.Group>
                        )}

                      {(values.type === "input" ||
                        values.type === "textarea") && (
                          <Form.Group className="mb-3" as={Col} sm={"12"}>
                            <Form.Label>Placeholder</Form.Label>
                            <Form.Control
                              type="text"
                              name="placeholder"
                              value={values.placeholder}
                              onChange={handleChange}
                              isInvalid={!!errors.placeholder}
                              isValid={touched.placeholder && !errors.placeholder}
                            />
                            <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                            <Form.Control.Feedback type="invalid">
                              {errors.placeholder}
                            </Form.Control.Feedback>
                          </Form.Group>
                        )}

                      {values.allowMultipleChoice === true && (
                        <>
                          <Form.Group className="mb-3" as={Col} sm={"6"}>
                            <Form.Label>Mínimo</Form.Label>
                            <Form.Control
                              type="number"
                              name="allowMultipleChoiceMin"
                              value={values.allowMultipleChoiceMin}
                              onChange={handleChange}
                              isInvalid={!!errors.allowMultipleChoiceMin}
                              isValid={
                                touched.allowMultipleChoiceMin &&
                                !errors.allowMultipleChoiceMin
                              }
                            />
                            <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                            <Form.Control.Feedback type="invalid">
                              {errors.allowMultipleChoiceMin}
                            </Form.Control.Feedback>
                          </Form.Group>
                          <Form.Group className="mb-3" as={Col} sm={"6"}>
                            <Form.Label>Máximo</Form.Label>
                            <Form.Control
                              type="number"
                              name="allowMultipleChoiceMax"
                              value={values.allowMultipleChoiceMax}
                              onChange={handleChange}
                              isInvalid={!!errors.allowMultipleChoiceMax}
                              isValid={
                                touched.allowMultipleChoiceMax &&
                                !errors.allowMultipleChoiceMax
                              }
                            />
                            <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                            <Form.Control.Feedback type="invalid">
                              {errors.allowMultipleChoiceMax}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </>
                      )}
                      {(values.type === "input" ||
                        values.type === "select") && (
                          <Form.Group as={Col} className={"mb-3"} sm={"12"}>
                            <Form.Label>
                              Tamanho do campo
                              <OverlayTrigger
                                overlay={
                                  <Tooltip>
                                    3/3 = 100% de largura<br></br>2/3 = 75% de
                                    largura<br></br>1.5/3 = 50% de largura
                                    <br></br>1/3 = 25% de largura
                                  </Tooltip>
                                }
                              >
                                <HelpTooltip icon={faExclamationCircle} />
                              </OverlayTrigger>
                            </Form.Label>
                            <Form.Select
                              name="col"
                              value={values.col}
                              onChange={(e) => {
                                setFieldValue("col", parseInt(e.target.value));
                              }}
                              isInvalid={!!errors.col}
                              isValid={touched.col && !errors.col}
                            >
                              {formColumns.map((element, index) => {
                                return (
                                  <option
                                    key={"colField" + index}
                                    value={element.value}
                                  >
                                    {element.description}
                                  </option>
                                );
                              })}
                            </Form.Select>
                            <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                            <Form.Control.Feedback type="invalid">
                              {errors.col}
                            </Form.Control.Feedback>
                          </Form.Group>
                        )}
                      <Form.Group as={Col} md="12" className={"mb-3"}>
                        <Form.Label>
                          Dependências
                          <OverlayTrigger
                            overlay={
                              <Tooltip>
                                Adicione dependências para controlar quando este
                                campo aparecerá. O campo só será mostrado se
                                TODAS as condições forem atendidas
                              </Tooltip>
                            }
                          >
                            <HelpTooltip icon={faExclamationCircle} />
                          </OverlayTrigger>
                        </Form.Label>

                        {values.dependencies &&
                          values.dependencies.length > 0 ? (
                          values.dependencies.map((dependency, depIndex) => (
                            <div
                              key={`dependency-${depIndex}`}
                              className="border rounded p-2 mb-2 position-relative"
                            >
                              {/* Remove icon in top right */}
                              <FontAwesomeIcon
                                icon={faTimes}
                                className="text-danger position-absolute"
                                style={{
                                  top: "10px",
                                  right: "10px",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  const newDependencies =
                                    values.dependencies.filter(
                                      (_, index) => index !== depIndex,
                                    );
                                  setFieldValue(
                                    "dependencies",
                                    newDependencies,
                                  );
                                }}
                              />
                              <Row>
                                <Col md={6}>
                                  <Form.Label>Campo</Form.Label>
                                  <Form.Select
                                    name={`dependencies[${depIndex}].inputID`}
                                    value={dependency.inputID || ""}
                                    onChange={(e) => {
                                      const newDependencies = [
                                        ...values.dependencies,
                                      ];

                                      const dependencyField = activeFields.find(
                                        (field) =>
                                          field.inputID.toString() ===
                                          e.target.value.toString(),
                                      );

                                      // Auto-set value for checkbox fields without options
                                      const showValueInput = !(
                                        dependencyField?.type === "checkbox" &&
                                        (!dependencyField.options ||
                                          dependencyField.options.length === 0)
                                      );

                                      newDependencies[depIndex] = {
                                        ...newDependencies[depIndex],
                                        inputID: e.target.value,
                                        value: !showValueInput ? true : "",
                                      };

                                      setFieldValue(
                                        "dependencies",
                                        newDependencies,
                                      );
                                    }}
                                    isInvalid={
                                      !!errors.dependencies?.[depIndex]?.inputID
                                    }
                                  >
                                    <option value={""}>
                                      Selecione um campo
                                    </option>
                                    {activeFields.map((element, index) => {
                                      if (element.inputID === values.inputID) {
                                        return null;
                                      }
                                      return (
                                        <option
                                          key={`dependenceSelect-${depIndex}-${index}`}
                                          value={element.inputID}
                                        >
                                          {element.label}
                                        </option>
                                      );
                                    })}
                                  </Form.Select>
                                  <Form.Control.Feedback type="invalid">
                                    {errors.dependencies?.[depIndex]?.inputID}
                                  </Form.Control.Feedback>
                                </Col>

                                {dependency.inputID &&
                                  dependency.value !== true && (
                                    <Col md={6}>
                                      <Form.Label>Valor</Form.Label>
                                      <Form.Control
                                        type="text"
                                        name={`dependencies[${depIndex}].value`}
                                        value={dependency.value || ""}
                                        onChange={(e) => {
                                          const newDependencies = [
                                            ...values.dependencies,
                                          ];
                                          newDependencies[depIndex] = {
                                            ...newDependencies[depIndex],
                                            value: e.target.value,
                                          };
                                          setFieldValue(
                                            "dependencies",
                                            newDependencies,
                                          );
                                        }}
                                        isInvalid={
                                          !!errors.dependencies?.[depIndex]
                                            ?.value
                                        }
                                      />
                                      <Form.Control.Feedback type="invalid">
                                        {errors.dependencies?.[depIndex]?.value}
                                      </Form.Control.Feedback>
                                    </Col>
                                  )}
                              </Row>
                            </div>
                          ))
                        ) : (
                          <p className="text-muted small mb-2">
                            Nenhuma dependência configurada
                          </p>
                        )}

                        <Button
                          variant="outline-primary"
                          size="sm"
                          onClick={() => {
                            const newDependencies = [
                              ...(values.dependencies || []),
                              { inputID: "", value: "" },
                            ];
                            setFieldValue("dependencies", newDependencies);
                          }}
                          className="mt-2"
                        >
                          + Adicionar Dependência
                        </Button>
                      </Form.Group>
                      <p className="text-start fw-bold mb-2">Formulário</p>
                      <Form.Group className="mb-3">
                        {platform === 1 &&
                          (!values.dependencies ||
                            values.dependencies.length === 0) &&
                          values.type === "input" && (
                            <Form.Check
                              checked={values.primary ? true : false}
                              type="checkbox"
                              name="primary"
                              label={
                                <>
                                  Campo primário
                                  <OverlayTrigger
                                    overlay={
                                      <Tooltip>
                                        Verifica se existe algum registro com
                                        esse valor no banco de dados
                                      </Tooltip>
                                    }
                                  >
                                    <HelpTooltip icon={faExclamationCircle} />
                                  </OverlayTrigger>
                                </>
                              }
                              onChange={(e) => {
                                setFieldValue(
                                  "primary",
                                  values.primary ? false : true,
                                );
                              }}
                            />
                          )}
                        <Form.Check
                          disabled={platform === 2 && values.whatsapp === true}
                          checked={values.required ? true : false}
                          type="checkbox"
                          name="required"
                          label="Preenchimento obrigatório"
                          onChange={(e) => {
                            setFieldValue(
                              "required",
                              values.required ? false : true,
                            );
                          }}
                        />
                        <Form.Check
                          disabled={platform === 2 && values.whatsapp === true}
                          checked={values.hideFieldOnRegister ? true : false}
                          type="checkbox"
                          name="hideFieldOnRegister"
                          label="Não mostrar campo no formulário do participante"
                          onChange={(e) => {
                            setFieldValue(
                              "hideFieldOnRegister",
                              values.hideFieldOnRegister ? false : true,
                            );
                          }}
                        />
                        {(values.type === "input" ||
                          values.type === "textarea") && (
                            <Form.Check
                              checked={values.fieldWithUppercase ? true : false}
                              type="checkbox"
                              name="fieldWithUppercase"
                              label="Texto com maiúsculo"
                              onChange={(e) => {
                                setFieldValue(
                                  "fieldWithUppercase",
                                  values.fieldWithUppercase ? false : true,
                                );
                              }}
                            />
                          )}
                        {values.blockEdit && (
                          <Form.Group as={Col} sm={"12"}>
                            <Form.Label>Mensagem</Form.Label>
                            <Form.Control
                              type="text"
                              name="blockEditMessage"
                              value={values.blockEditMessage}
                              onChange={handleChange}
                              isInvalid={!!errors.blockEditMessage}
                              isValid={
                                touched.blockEditMessage &&
                                !errors.blockEditMessage
                              }
                            />
                            <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                            <Form.Control.Feedback type="invalid">
                              {errors.blockEditMessage}
                            </Form.Control.Feedback>
                          </Form.Group>
                        )}
                      </Form.Group>
                      {(platform === 2 ||
                        ((!values.dependencies ||
                          values.dependencies.length === 0) &&
                          values.type === "input" &&
                          !user)) && (
                          <Form.Group className="mb-3">
                            <p className="text-start fw-bold mb-2">Plataformas</p>
                            {(!values.dependencies ||
                              values.dependencies.length === 0) &&
                              values.type === "input" &&
                              !user && (
                                <Form.Check
                                  checked={values.fieldToShow ? true : false}
                                  type="checkbox"
                                  name="fieldToShow"
                                  label={
                                    <>
                                      Campo de identificação
                                      <OverlayTrigger
                                        overlay={
                                          <Tooltip>
                                            Quando necessário mostrar alguma
                                            informação do(s) participante(s), esse
                                            campo será escolhido
                                          </Tooltip>
                                        }
                                      >
                                        <HelpTooltip icon={faExclamationCircle} />
                                      </OverlayTrigger>
                                    </>
                                  }
                                  onChange={(e) => {
                                    setFieldValue(
                                      "fieldToShow",
                                      values.fieldToShow ? false : true,
                                    );
                                  }}
                                  isInvalid={!!errors.fieldToShow}
                                  feedback={errors.fieldToShow}
                                  feedbackType="invalid"
                                />
                              )}
                            {whatsappControl(values, setFieldValue)}
                            {platform === 2 && (
                              <>
                                <Form.Check
                                  checked={values.blockEdit ? true : false}
                                  type="checkbox"
                                  name="blockEdit"
                                  label={"Bloquear edição após registro"}
                                  onChange={(e) => {
                                    setFieldValue(
                                      "blockEdit",
                                      values.blockEdit ? false : true,
                                    );
                                  }}
                                />
                                <Form.Check
                                  checked={!values.displayField ? true : false}
                                  type="checkbox"
                                  name="displayField"
                                  label={
                                    <>
                                      Informação confidencial
                                      <OverlayTrigger
                                        overlay={
                                          <Tooltip>
                                            Esconder campo para os outros
                                            participantes
                                          </Tooltip>
                                        }
                                      >
                                        <HelpTooltip icon={faExclamationCircle} />
                                      </OverlayTrigger>
                                    </>
                                  }
                                  onChange={(e) => {
                                    setFieldValue(
                                      "displayField",
                                      values.displayField ? false : true,
                                    );
                                  }}
                                />
                                {!user && (values.rfigtag ||
                                  (values.type === "input" &&
                                    values.validation === "text")) && (
                                    <Form.Check
                                      checked={values.rfigtag ? true : false}
                                      type="checkbox"
                                      name="rfigtag"
                                      disabled={platform === 2 && values.whatsapp === true}
                                      label={
                                        <>
                                          Identificar como RFID Tag
                                          <OverlayTrigger
                                            overlay={
                                              <Tooltip>
                                                Indentifica como um campo RFID
                                                para ser utilizado no
                                                credenciamento e em aplicativos que utilizam o RFID

                                              </Tooltip>
                                            }
                                          >
                                            <HelpTooltip
                                              icon={faExclamationCircle}
                                            />
                                          </OverlayTrigger>
                                        </>
                                      }
                                      onChange={() => {
                                        handleRfidTagChange(
                                          setFieldValue,
                                          values.rfigtag,
                                        );
                                      }}
                                    />
                                  )}
                              </>
                            )}
                          </Form.Group>
                        )}
                      <Form.Group>
                        <p className="text-start fw-bold mb-2">Relatórios</p>
                        <Form.Check
                          checked={values.showInUserReport ? true : false}
                          type="checkbox"
                          name="showInUserReport"
                          label={"Destacar campo nos relatórios"}
                          onChange={(e) => {
                            setFieldValue(
                              "showInUserReport",
                              values.showInUserReport ? false : true,
                            );
                          }}
                        />
                      </Form.Group>
                    </>
                  ) : (
                    <>
                      {values.dependencies &&
                        values.dependencies.length > 0 && (
                          <Form.Group as={Col} md="12" className={"mb-3"}>
                            <Form.Label>
                              Dependências
                              <OverlayTrigger
                                overlay={
                                  <Tooltip>
                                    Adicione dependências para controlar quando
                                    este campo aparecerá. O campo só será
                                    mostrado se TODAS as condições forem
                                    atendidas
                                  </Tooltip>
                                }
                              >
                                <HelpTooltip icon={faExclamationCircle} />
                              </OverlayTrigger>
                            </Form.Label>

                            {values.dependencies &&
                              values.dependencies.length > 0 ? (
                              values.dependencies.map(
                                (dependency, depIndex) => (
                                  <div
                                    key={`dependency-${depIndex}`}
                                    className="border rounded p-2 mb-2 position-relative"
                                  >
                                    {/* Remove icon in top right */}
                                    <FontAwesomeIcon
                                      icon={faTimes}
                                      className="text-danger position-absolute"
                                      style={{
                                        top: "10px",
                                        right: "10px",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        const newDependencies =
                                          values.dependencies.filter(
                                            (_, index) => index !== depIndex,
                                          );
                                        setFieldValue(
                                          "dependencies",
                                          newDependencies,
                                        );
                                      }}
                                    />
                                    <Row>
                                      <Col md={6}>
                                        <Form.Label>Campo</Form.Label>
                                        <Form.Select
                                          name={`dependencies[${depIndex}].inputID`}
                                          value={dependency.inputID || ""}
                                          onChange={(e) => {
                                            const newDependencies = [
                                              ...values.dependencies,
                                            ];

                                            const dependencyField =
                                              activeFields.find(
                                                (field) =>
                                                  field.inputID.toString() ===
                                                  e.target.value.toString(),
                                              );

                                            // Auto-set value for checkbox fields without options
                                            const showValueInput = !(
                                              dependencyField?.type ===
                                              "checkbox" &&
                                              (!dependencyField.options ||
                                                dependencyField.options
                                                  .length === 0)
                                            );

                                            newDependencies[depIndex] = {
                                              ...newDependencies[depIndex],
                                              inputID: e.target.value,
                                              value: !showValueInput
                                                ? true
                                                : "",
                                            };

                                            setFieldValue(
                                              "dependencies",
                                              newDependencies,
                                            );
                                          }}
                                          isInvalid={
                                            !!errors.dependencies?.[depIndex]
                                              ?.inputID
                                          }
                                        >
                                          <option value={""}>
                                            Selecione um campo
                                          </option>
                                          {activeFields.map(
                                            (element, index) => {
                                              if (
                                                element.inputID ===
                                                values.inputID
                                              ) {
                                                return null;
                                              }
                                              return (
                                                <option
                                                  key={`dependenceSelect-${depIndex}-${index}`}
                                                  value={element.inputID}
                                                >
                                                  {element.label}
                                                </option>
                                              );
                                            },
                                          )}
                                        </Form.Select>
                                        <Form.Control.Feedback type="invalid">
                                          {
                                            errors.dependencies?.[depIndex]
                                              ?.inputID
                                          }
                                        </Form.Control.Feedback>
                                      </Col>

                                      {dependency.inputID &&
                                        dependency.value !== true && (
                                          <Col md={6}>
                                            <Form.Label>Valor</Form.Label>
                                            <Form.Control
                                              type="text"
                                              name={`dependencies[${depIndex}].value`}
                                              value={dependency.value || ""}
                                              onChange={(e) => {
                                                const newDependencies = [
                                                  ...values.dependencies,
                                                ];
                                                newDependencies[depIndex] = {
                                                  ...newDependencies[depIndex],
                                                  value: e.target.value,
                                                };
                                                setFieldValue(
                                                  "dependencies",
                                                  newDependencies,
                                                );
                                              }}
                                              isInvalid={
                                                !!errors.dependencies?.[
                                                  depIndex
                                                ]?.value
                                              }
                                            />
                                            <Form.Control.Feedback type="invalid">
                                              {
                                                errors.dependencies?.[depIndex]
                                                  ?.value
                                              }
                                            </Form.Control.Feedback>
                                          </Col>
                                        )}
                                    </Row>
                                  </div>
                                ),
                              )
                            ) : (
                              <p className="text-muted small mb-2">
                                Nenhuma dependência configurada
                              </p>
                            )}

                            <Button
                              variant="outline-primary"
                              size="sm"
                              onClick={() => {
                                const newDependencies = [
                                  ...(values.dependencies || []),
                                  { inputID: "", value: "" },
                                ];
                                setFieldValue("dependencies", newDependencies);
                              }}
                              className="mt-2"
                            >
                              + Adicionar Dependência
                            </Button>
                          </Form.Group>
                        )}
                      <p className="text-start fw-bold mb-2">Formulário</p>
                      <Form.Group className="mb-3">
                        {platform === 1 &&
                          (!values.dependencies ||
                            values.dependencies.length === 0) &&
                          values.type === "input" && (
                            <Form.Check
                              checked={values.primary ? true : false}
                              type="checkbox"
                              name="primary"
                              label={
                                <>
                                  Campo primário
                                  <OverlayTrigger
                                    overlay={
                                      <Tooltip>
                                        Verifica se existe algum registro com
                                        esse valor no banco de dados
                                      </Tooltip>
                                    }
                                  >
                                    <HelpTooltip icon={faExclamationCircle} />
                                  </OverlayTrigger>
                                </>
                              }
                              onChange={(e) => {
                                setFieldValue(
                                  "primary",
                                  values.primary ? false : true,
                                );
                              }}
                            />
                          )}
                        <Form.Check
                          disabled={platform === 2 && values.whatsapp === true}
                          checked={values.required ? true : false}
                          type="checkbox"
                          name="required"
                          label="Preenchimento obrigatório"
                          onChange={(e) => {
                            setFieldValue(
                              "required",
                              values.required ? false : true,
                            );
                          }}
                        />
                      </Form.Group>

                      {(!values.dependencies ||
                        values.dependencies.length === 0) &&
                        values.type === "input" && (
                          <>
                            <p className="text-start fw-bold mb-2">
                              Plataformas
                            </p>
                            <Form.Group>
                              {whatsappControl(values, setFieldValue)}
                              <Form.Check
                                checked={values.fieldToShow ? true : false}
                                type="checkbox"
                                name="fieldToShow"
                                label={
                                  <>
                                    Campo de identificação
                                    <OverlayTrigger
                                      overlay={
                                        <Tooltip>
                                          Quando necessário mostrar alguma
                                          informação do(s) participante(s), esse
                                          campo será escolhido
                                        </Tooltip>
                                      }
                                    >
                                      <HelpTooltip icon={faExclamationCircle} />
                                    </OverlayTrigger>
                                  </>
                                }
                                onChange={(e) => {
                                  setFieldValue(
                                    "fieldToShow",
                                    values.fieldToShow ? false : true,
                                  );
                                }}
                                isInvalid={!!errors.fieldToShow}
                                feedback={errors.fieldToShow}
                                feedbackType="invalid"
                              />
                              {platform === 2 && !user &&
                                (values.rfigtag ||
                                  values.validation === "text") && (
                                  <Form.Check
                                    checked={values.rfigtag ? true : false}
                                    type="checkbox"
                                    name="rfigtag"
                                    disabled={platform === 2 && values.whatsapp === true}
                                    label={
                                      <>
                                        Identificar como RFID Tag
                                        <OverlayTrigger
                                          overlay={
                                            <Tooltip>
                                              Indentifica como um campo RFID
                                              para ser utilizado no
                                              credenciamento e em aplicativos que utilizam o RFID
                                            </Tooltip>
                                          }
                                        >
                                          <HelpTooltip
                                            icon={faExclamationCircle}
                                          />
                                        </OverlayTrigger>
                                      </>
                                    }
                                    onChange={() => {
                                      handleRfidTagChange(
                                        setFieldValue,
                                        values.rfigtag,
                                      );
                                    }}
                                  />
                                )}
                            </Form.Group>
                          </>
                        )}
                      <Form.Group as={Col} md="12" className="mt-3 text-center">
                        <Button
                          variant="primary"
                          type="button"
                          className="btn-sm"
                          onClick={() => {
                            setShowAdditionalData(true);
                          }}
                        >
                          Mostrar mais opções
                        </Button>
                      </Form.Group>
                    </>
                  )}
                </Row>
              </Modal.Body>
              <Modal.Footer>
                {modal.showModalForm || modal.showModalFormUser ? (
                  <Button
                    variant="danger"
                    type="button"
                    className="float-end me-2"
                    onClick={() => {
                      const closeFieldModal = () => {
                        if (user) {
                          setModal((prevState) => ({
                            ...prevState,
                            showModalFormUser: false,
                          }));
                        } else {
                          setModal((prevState) => ({
                            ...prevState,
                            showModalForm: false,
                          }));
                        }
                      };
                      const removeField = () => {
                        const removed = removeFieldForm(values.inputID);
                        if (removed) closeFieldModal();
                      };

                      removeField();
                    }}
                  >
                    Excluir
                  </Button>
                ) : (
                  ""
                )}
                <Button
                  variant="primary"
                  type="submit"
                  className="float-end"
                  disabled={isSubmitting}
                >
                  Salvar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export const SocialMediaType = ({
  dataAddForm,
  setDataAddForm,
  modal,
  setModal,
}) => {
  const addSocialMedia = (values, actions) => {
    const newObject = values;
    setDataAddForm((prevDataAddForm) => {
      const indexToUpdate = prevDataAddForm.socialMedia.findIndex(
        (field) => field.socialMediaID === values.socialMediaID,
      );
      let newDataAddForm = [...prevDataAddForm.socialMedia];

      if (indexToUpdate !== -1) {
        newDataAddForm[indexToUpdate] = newObject;
      } else {
        newDataAddForm = [...newDataAddForm, newObject];
      }
      return {
        ...prevDataAddForm,
        socialMedia: newDataAddForm,
      };
    });
    setModal((prevState) => ({
      ...prevState,
      showSocialMediaForm: false,
    }));
    setDataAddForm((prevState) => ({
      ...prevState,
      addFieldData: false,
    }));
  };

  const removeSocialMedia = (socialMediaID) => {
    setDataAddForm((prevDataAddForm) => {
      const indexToRemove = prevDataAddForm.socialMedia.findIndex(
        (field) => field.socialMediaID === socialMediaID,
      );
      const newDataAddForm = [...prevDataAddForm.socialMedia];
      newDataAddForm.splice(indexToRemove, 1);
      return {
        ...prevDataAddForm,
        socialMedia: newDataAddForm,
      };
    });
  };

  return (
    <>
      <Modal
        show={modal.showSocialMediaForm}
        size={"sm"}
        onHide={(e) => {
          setModal((prevState) => ({
            ...prevState,
            showSocialMediaForm: false,
          }));
          setDataAddForm((prevState) => ({
            ...prevState,
            addFieldData: false,
          }));
        }}
        fullscreen={"sm-down"}
        centered
        backdrop={true}
        style={{ zIndex: 1062 }}
        backdropClassName="nested-modal-backdrop-lv2"
      >
        <Formik
          validationSchema={schemaAddSocialMedia}
          enableReinitialize
          onSubmit={addSocialMedia}
          initialValues={{
            socialMediaID:
              dataAddForm.addFieldData.socialMediaID !== undefined
                ? dataAddForm.addFieldData.socialMediaID
                : generateSixDigitCode(),
            name:
              dataAddForm.addFieldData.name !== undefined
                ? dataAddForm.addFieldData.name
                : socialMediaX[0],
            url:
              dataAddForm.addFieldData.url !== undefined
                ? dataAddForm.addFieldData.url
                : "",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            values,
            touched,
            isValid,
            errors,
            dirty,
            isSubmitting,
            setFieldValue,
          }) => (
            <Form noValidate onSubmit={handleSubmit}>
              <Modal.Header closeButton>
                <Modal.Title>
                  {dataAddForm.addFieldData
                    ? "Editar rede social"
                    : "Adicionar rede social"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Row className="mb-3">
                  <Form.Group as={Col} className={"mb-3"} sm={"12"}>
                    <Form.Label>Escolha uma rede social</Form.Label>
                    <Form.Select
                      name="name"
                      value={values.name}
                      onChange={(e) => {
                        setFieldValue("name", e.target.value);
                      }}
                      isInvalid={!!errors.name}
                      isValid={touched.name && !errors.name}
                    >
                      {socialMediaX.map((element, index) => {
                        const capitalizeFirstLetter = ([
                          firstLetter,
                          ...rest
                        ]) => firstLetter.toUpperCase() + rest.join("");
                        const capitalizedString =
                          capitalizeFirstLetter(element);

                        return (
                          <option key={"fieldType" + index} value={element}>
                            {capitalizedString}
                          </option>
                        );
                      })}
                    </Form.Select>
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                      {errors.name}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} sm={"12"}>
                    <Form.Label>URL</Form.Label>
                    <Form.Control
                      type="text"
                      name="url"
                      value={values.url}
                      onChange={handleChange}
                      isInvalid={!!errors.url}
                      isValid={touched.url && !errors.url}
                    />
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                      {errors.url}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                {dataAddForm.addFieldData ? (
                  <Button
                    variant="danger"
                    type="button"
                    className="float-end me-2"
                    onClick={() => {
                      removeSocialMedia(values.socialMediaID);
                      setModal((prevState) => ({
                        ...prevState,
                        showSocialMediaForm: false,
                      }));
                    }}
                  >
                    Excluir
                  </Button>
                ) : (
                  ""
                )}
                <Button
                  variant="primary"
                  type="submit"
                  className="float-end"
                  disabled={isSubmitting}
                >
                  Salvar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export const BackgroundFormComponent = ({
  touched,
  errors,
  values,
  setFieldValue,
  handlePreviewSuccess,
  handlePreviewError,
  platform,
}) => {
  switch (values.json.background.type) {
    case "image":
      return (
        <Form.Group as={Col} className="mb-3">
          <Card className="mb-0">
            <Card.Body>
              <Form.Control
                type="hidden"
                name="json.background.url"
                value={values.json.background.url}
                onChange={(e) => {
                  setFieldValue("json.background.url", e.target.value);
                }}
                isInvalid={!!errors?.json?.background?.url}
                isValid={
                  touched?.json?.background?.url &&
                  !errors?.json?.background?.url
                }
              />
              <div className="imagesUpload">
                <img
                  className={`h-100 img-thumbnail ${!!errors?.json?.background?.url ? "is-invalid" : ""}`}
                  src={
                    values.json.background.url !== "" &&
                      values.json.background.url !== null
                      ? domainConfig.imageServer +
                      (platform === 1 ? "/evento/" : "/plataforma-eventos/") +
                      (platform === 1 ? values.evento_id : values.event_id) +
                      "/" +
                      values.json.background.url
                      : domainConfig.imageServer + "/empty-background.png"
                  }
                  alt="Imagem preview"
                />
                <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  {errors.json?.background?.url}
                </Form.Control.Feedback>
              </div>
              <DropzoneComponent
                className="mt-3 dropzoneComp"
                type="image"
                handlePreviewSuccess={handlePreviewSuccess}
                handlePreviewError={handlePreviewError}
                setFieldValue={setFieldValue}
                folder={platform === 1 ? "evento" : "plataforma-eventos"}
                id={platform === 1 ? values.evento_id : values.event_id}
                field="json.background.url"
              />
            </Card.Body>
          </Card>
        </Form.Group>
      );
    case "video":
      return (
        <Form.Group as={Col} className="mb-3">
          <Card className="mb-0">
            <Card.Body>
              <Form.Control
                type="hidden"
                name="json.background.url"
                value={values.json.background.url}
                onChange={(e) => {
                  setFieldValue("json.background.url", e.target.value);
                }}
                isInvalid={!!errors?.json?.background?.url}
                isValid={
                  touched?.json?.background?.url &&
                  !errors?.json?.background?.url
                }
              />
              <div className="imagesUpload">
                <video
                  className={`h-100 img-thumbnail ${!!errors?.json?.background?.url ? "is-invalid" : ""}`}
                  src={
                    values.json.background.url !== "" &&
                      values.json.background.url !== null
                      ? domainConfig.imageServer +
                      (platform === 1 ? "/evento/" : "/plataforma-eventos/") +
                      (platform === 1 ? values.evento_id : values.event_id) +
                      "/" +
                      values.json.background.url
                      : domainConfig.imageServer + "/empty-background.png"
                  }
                  controls={true}
                />
                <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  {errors.json?.background?.url}
                </Form.Control.Feedback>
              </div>
              <DropzoneComponent
                className="mt-3 dropzoneComp"
                type="video"
                handlePreviewSuccess={handlePreviewSuccess}
                handlePreviewError={handlePreviewError}
                setFieldValue={setFieldValue}
                folder={platform === 1 ? "evento" : "plataforma-eventos"}
                id={platform === 1 ? values.evento_id : values.event_id}
                field="json.background.url"
              />
            </Card.Body>
          </Card>
        </Form.Group>
      );
    default:
      return "";
  }
};

export function handlePreviewSuccess(filename, setFieldValue, field) {
  setFieldValue(field, filename);
}

export function handlePreviewSuccessMultiple(
  uploadResults,
  dataAddForm,
  setDataAddForm,
) {
  const currentGalleryCount = dataAddForm.gallery?.length || 0;
  const maxImages = 8;
  const availableSlots = maxImages - currentGalleryCount;

  if (availableSlots <= 0) {
    console.warn("Galeria já possui o máximo de 8 imagens");
    return;
  }

  // Limit the upload results to available slots
  const limitedResults = uploadResults.slice(0, availableSlots);

  const newGalleryItems = limitedResults.map((result) => ({
    id: generateSixDigitCode(),
    image: result.filename,
    width: "300",
    height: "300",
  }));

  setDataAddForm((prevDataAddForm) => ({
    ...prevDataAddForm,
    gallery: [...prevDataAddForm.gallery, ...newGalleryItems],
  }));
}

export function handleDelete(
  props,
  platform,
  setLoading,
  notyf,
  dispatch,
  eventList,
) {
  confirmAlert({
    closeOnEscape: false,
    closeOnClickOutside: false,
    customUI: ({ onClose }) => {
      return (
        <ShowConfirm
          title="Confirmar ação"
          description="Deseja remover esse evento? O link de acesso ao aplicativo será desativado e todos os dados relacionados ao evento serão excluídos."
          action={deleteEvent}
          onClose={onClose}
          param={{ props, platform, setLoading, notyf, dispatch, eventList }}
        />
      );
    },
  });
}

export function deleteEvent({
  props,
  platform,
  setLoading,
  notyf,
  dispatch,
  eventList,
}) {
  const eventId = props.evento_id ?? props.event_id;

  if (!eventId) {
    notyf.open({
      type: "danger",
      message: "Não foi possível identificar o evento para exclusão",
      ripple: true,
      dismissible: true,
    });
    return;
  }

  setLoading(true);
  axios
    .delete(`/api/event/${eventId}`, {
      data: { platform: platform },
    })
    .then(function (response) {
      setLoading(false);
      dispatch(eventList({ fetch: true }));
    })
    .catch(function (error) {
      setLoading(false);
      notyf.open({
        type: "danger",
        message: "Houve um erro, tente novamente",
        ripple: true,
        dismissible: true,
      });
    });
}

export function registerToggle(
  props,
  status,
  platform,
  setLoading,
  notyf,
  dispatch,
  eventList,
) {
  setLoading(true);
  try {
    const updatedValues = JSON.parse(JSON.stringify(props));
    updatedValues.json.form.status = status;

    let nextEventEndDate = null;
    if (status) {
      const currentEventEndDate =
        platform === 2
          ? props.end_date || props.data_termino
          : props.data_termino || props.end_date;
      const reactivationDates = getReactivationDates(currentEventEndDate);
      updatedValues.json.form.register_end_date =
        reactivationDates.formattedRegisterEndDate;
      nextEventEndDate = reactivationDates.formattedEventEndDate;
    }

    axios
      .put(`/api/event/${props.evento_id}`, {
        json: JSON.stringify(updatedValues.json),
        platform: platform,
        ...(status && platform === 1 ? { data_termino: nextEventEndDate } : {}),
        ...(status && platform === 2 ? { end_date: nextEventEndDate } : {}),
      })
      .then(function (response) {
        console.log("registerToggle success");
        setLoading(false);
        if (status) {
          notyf.open({
            type: "success",
            message: "Inscrição ativada com sucesso",
            ripple: true,
            dismissible: true,
          });
        } else {
          notyf.open({
            type: "success",
            message: "Inscrição desativada com sucesso",
            ripple: true,
            dismissible: true,
          });
        }
        dispatch(eventList({ fetch: true }));
      })
      .catch(function (error) {
        console.log("registerToggle error", error);
        setLoading(false);
        notyf.open({
          type: "danger",
          message: "Houve um erro, tente novamente",
          ripple: true,
          dismissible: true,
        });
      });
  } catch (error) {
    console.error("registerToggle sync error", error);
    setLoading(false);
    notyf.open({
      type: "danger",
      message: "Erro ao processar solicitação",
      ripple: true,
      dismissible: true,
    });
  }
}

export function handleEndEvent(
  props,
  platform,
  setLoading,
  notyf,
  dispatch,
  eventList,
) {
  confirmAlert({
    closeOnEscape: false,
    closeOnClickOutside: false,
    customUI: ({ onClose }) => {
      return (
        <ShowConfirm
          title="Confirmar ação"
          description="Deseja finalizar esse evento? O link de acesso ao aplicativo será desativado."
          action={endEvent}
          onClose={onClose}
          param={{ props, platform, setLoading, notyf, dispatch, eventList }}
        />
      );
    },
  });
}

export function startEvent(
  props,
  platform,
  setLoading,
  notyf,
  dispatch,
  eventList,
) {
  setLoading(true);
  axios
    .put(`/api/event/${props.evento_id}`, {
      status: 2,
      platform: platform,
    })
    .then(function (response) {
      setLoading(false);
      notyf.open({
        type: "success",
        message: "Evento iniciado com sucesso",
        ripple: true,
        dismissible: true,
      });
      dispatch(eventList({ fetch: true }));
    })
    .catch(function (error) {
      setLoading(false);
      notyf.open({
        type: "danger",
        message: "Houve um erro, tente novamente",
        ripple: true,
        dismissible: true,
      });
    });
}

export function endEvent({
  props,
  platform,
  setLoading,
  notyf,
  dispatch,
  eventList,
}) {
  setLoading(true);
  axios
    .put(`/api/event/${props.evento_id}`, {
      status: 4,
      platform: platform,
    })
    .then(function (response) {
      setLoading(false);
      notyf.open({
        type: "success",
        message: "Evento encerrado com sucesso",
        ripple: true,
        dismissible: true,
      });
      dispatch(eventList({ fetch: true }));
    })
    .catch(function (error) {
      setLoading(false);
      notyf.open({
        type: "danger",
        message: "Houve um erro, tente novamente",
        ripple: true,
        dismissible: true,
      });
    });
}

export const EmailLabelModal = ({ modal, setModal, values, setFieldValue }) => {
  const [emailLabel, setEmailLabel] = useState(
    values?.json?.form?.emailLabel || "E-mail",
  );
  const [error, setError] = useState("");

  React.useEffect(() => {
    if (modal.showModalEmailLabel) {
      setEmailLabel(values?.json?.form?.emailLabel || "E-mail");
      setError("");
    }
  }, [modal.showModalEmailLabel, values?.json?.form?.emailLabel]);

  const handleSave = () => {
    // Validation
    if (!emailLabel || emailLabel.trim() === "") {
      setError("Campo obrigatório");
      return;
    }
    if (emailLabel.length > 100) {
      setError("Máximo de 100 caracteres");
      return;
    }

    // Save the value
    setFieldValue("json.form.emailLabel", emailLabel);

    // Close modal
    setModal((prevState) => ({
      ...prevState,
      showModalEmailLabel: false,
    }));
  };

  return (
    <Modal
      show={modal.showModalEmailLabel}
      size={"sm"}
      onHide={() => {
        setModal((prevState) => ({
          ...prevState,
          showModalEmailLabel: false,
        }));
      }}
      centered
      backdrop="static"
      style={{ zIndex: 1064 }}
      backdropClassName="nested-modal-backdrop-lv3"
    >
      <Modal.Header closeButton>
        <Modal.Title>Editar campo</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label>Título</Form.Label>
          <Form.Control
            type="text"
            value={emailLabel}
            onChange={(e) => {
              setEmailLabel(e.target.value);
              setError("");
            }}
            isInvalid={!!error}
            placeholder="E-mail"
            maxLength={100}
          />
          <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
        </Form.Group>
        <Form.Group className="mb-3">
          <p className="text-start fw-bold mb-2">Relatórios</p>
          <Form.Check
            checked={values?.json?.form?.showEmailInUserReport !== false}
            type="checkbox"
            name="json.form.showEmailInUserReport"
            label="Destacar e-mail nos relatórios"
            onChange={() => {
              setFieldValue(
                "json.form.showEmailInUserReport",
                values?.json?.form?.showEmailInUserReport !== false ? false : true,
              );
            }}
          />
        </Form.Group>
        <Form.Group>
          <p className="text-start fw-bold mb-2">Plataformas</p>
          <Form.Check
            checked={values?.json?.credentialAccess?.removeEmail ? true : false}
            type="checkbox"
            name="json.credentialAccess.removeEmail"
            label={<>
              Remover email do formulário <OverlayTrigger
                overlay={
                  <Tooltip>
                    E-mail serão gerados automaticamentes. Recomendado apenas quando não utilizar o Networking
                  </Tooltip>
                }
              >
                <HelpTooltip icon={faExclamationCircle} />
              </OverlayTrigger>
            </>}
            onChange={() => {
              setFieldValue(
                "json.credentialAccess.removeEmail",
                values?.json?.credentialAccess?.removeEmail ? false : true,
              );
            }}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => {
            setModal((prevState) => ({
              ...prevState,
              showModalEmailLabel: false,
            }));
          }}
        >
          Cancelar
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Salvar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export const RecommendedSizeModal = ({ modal, setModal }) => {
  const [animationStarted, setAnimationStarted] = useState(false);

  // Start animation when modal opens
  React.useEffect(() => {
    if (modal.showRecommendedSizeModal) {
      setAnimationStarted(false);
      const timer = setTimeout(() => {
        setAnimationStarted(true);
      }, 1250);
      return () => clearTimeout(timer);
    }
  }, [modal.showRecommendedSizeModal]);

  const containerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "250px",
    position: "relative",
  };

  const outerSquareStyle = {
    width: "300px",
    height: "200px",
    border: "2px solid #007bff",
    borderRadius: "10px",
    position: "absolute",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#f8f9fa",
  };

  const innerSquareStyle = {
    width: animationStarted ? "180px" : "300px",
    height: animationStarted ? "200px" : "200px",
    border: "2px solid #dc3545",
    borderRadius: "10px",
    backgroundColor: "#fff3cd",
    transition: "all 1.5s ease-in-out",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    opacity: animationStarted ? 1 : 0,
    zIndex: 1,
  };

  return (
    <Modal
      show={modal.showRecommendedSizeModal}
      size={"sm"}
      onHide={() => {
        setAnimationStarted(false); // Reset animation when modal closes
        setModal((prevState) => ({
          ...prevState,
          showRecommendedSizeModal: false,
        }));
      }}
      centered
      backdrop="static"
      style={{ zIndex: 1064 }}
      backdropClassName="nested-modal-backdrop-lv3"
    >
      <Modal.Header closeButton>
        <Modal.Title>Demonstração de Adaptação de Imagem</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="text-center mb-3">
          <p className="small">
            Escolha uma imagem no qual o conteúdo principal esteja centralizado,
            evitando que informações importantes sejam cortadas em diferentes
            dispositivos.
          </p>
        </div>

        <div style={containerStyle}>
          <div style={outerSquareStyle}>Imagem</div>
          <div style={innerSquareStyle}>Imagem</div>
        </div>

        <div className="text-center mt-3">
          <small className="text-muted">
            <strong>Azul:</strong>Tamanho máximo | <strong>Vermelho:</strong>{" "}
            Tamanho mínimo
          </small>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export const eventX = ["Plataforma de aplicativos", "Plataforma de eventos"];
export const colorsX = ["secondary", "warning", "success", "danger", "black"];
export const statusX = [
  "Rascunho",
  "Não iniciado",
  "Em andamento",
  "Parado",
  "Encerrado",
];
export const layoutX = ["Espaçado", "Centralizado"];
export const formColumns = [
  { description: "3/3", value: 12 },
  { description: "2/3", value: 8 },
  { description: "1.5/3", value: 6 },
  { description: "1/3", value: 4 },
];
export const socialMediaX = [
  "facebook",
  "instagram",
  "youtube",
  "linkedin",
  "twitter",
  "website",
  "whatsapp",
];
export const fieldsTypeX = [
  {
    name: "Texto",
    type: "input",
    validations: [
      { label: "Texto", value: "text" },
      { label: "Número", value: "number" },
      { label: "E-mail", value: "email" },
      { label: "Texto grande", value: "textBig" },
      { label: "Celular", value: "telefone" },
      { label: "CPF", value: "cpf" },
      { label: "CNPJ", value: "cnpj" },
      { label: "Data", value: "date" },
    ],
  },
  {
    name: "Seleção",
    type: "select",
    validations: [{ label: "Texto", value: "text" }],
  },
  {
    name: "Checkbox",
    type: "checkbox",
    validations: [{ label: "Checkbox", value: "checkbox" }],
  },
  {
    name: "Área de texto",
    type: "textarea",
    validations: [
      { label: "Texto", value: "text" },
      { label: "Número", value: "number" },
      { label: "E-mail", value: "email" },
      { label: "Texto grande", value: "textBig" },
      { label: "Celular", value: "telefone" },
      { label: "CPF", value: "cpf" },
      { label: "Data", value: "date" },
    ],
  },
];
